import React from "react"
import Requests from "@/components/Requests"

const RequestsView = () => {
  return <Requests />
}

export default RequestsView
